import { useState } from 'react';

export default function Reviews() {
  const [selectedVideo, setSelectedVideo] = useState<number | null>(null);

  const letterTestimonials = [
    {
      name: 'Sarah Mitchell',
      location: 'Richmond, VA',
      date: 'December 2025',
      homeImage: 'https://public.readdy.ai/ai/img_res/f5355863dd9407b5f48b364590d6f4e1.jpg',
      letter: 'We were dreading the window replacement process after hearing horror stories from neighbors, but SnapWindows made it simple and stress free. Billy handled the measurements with precision, and the quote stayed exactly as promised with no surprises. The installation crew was professional, kept everything clean, and finished in just one day. We immediately noticed lower energy bills and a much quieter home.'
    },
    {
      name: 'Michael Stevens',
      location: 'Glen Allen, VA',
      date: 'January 2026',
      homeImage: 'https://readdy.ai/api/search-image?query=Contemporary%20home%20exterior%20with%20large%20new%20windows%20modern%20architectural%20design%20premium%20residential%20photography&width=300&height=300&seq=home-stevens&orientation=squarish',
      letter: 'As someone who values efficiency and transparency, I appreciated how straightforward the entire process was from the beginning. There was no pressure, just clear communication and professionalism throughout. The project manager who handled the measurements was thorough, and the installation was seamless with everything left clean and in order. The windows look incredible, and my home office finally has the natural light I was hoping for.'
    },
    {
      name: 'Patricia Williams',
      location: 'Richmond, VA',
      date: 'November 2025',
      homeImage: 'https://readdy.ai/api/search-image?query=Charming%20traditional%20home%20exterior%20with%20new%20double%20hung%20windows%20beautiful%20curb%20appeal%20premium%20residential%20photography&width=300&height=300&seq=home-williams&orientation=squarish',
      letter: 'As a single mother with two kids, I needed windows that would keep our home safe and comfortable without stretching my budget. SnapWindows delivered exactly that with clear pricing, an accurate timeline, and excellent quality. The entire process felt easy and trustworthy from start to finish. My kids can safely open and close the windows, and our home feels brighter and more comfortable every day.'
    },
    {
      name: 'James & Carol Martinez',
      location: 'Henrico, VA',
      date: 'October 2025',
      homeImage: 'https://readdy.ai/api/search-image?query=Elegant%20home%20exterior%20with%20new%20bay%20windows%20classic%20design%20premium%20residential%20photography%20golden%20hour%20light&width=300&height=300&seq=home-martinez&orientation=squarish',
      letter: 'We have lived in our home for over 30 years, and our windows were long overdue for replacement. After meeting with several companies, SnapWindows stood out for its straightforward and no pressure approach. The entire process felt calm, professional, and easy to navigate. The new windows are beautiful, energy efficient, and have completely transformed the look and comfort of our home.'
    }
  ];

  return (
    <section id="reviews" className="py-section bg-gradient-to-br from-[#F6D7DF]/30 via-white to-[#C8D8E4]/30">
      <div className="max-w-content mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-heading font-semibold text-[#2B6777] mb-4 tracking-tight">
            Testimonials
          </h2>
          <p className="text-lg text-[#2B6777]/60 max-w-2xl mx-auto">
            Real homeowners. Real experiences. No manufactured reviews.
          </p>
        </div>

        {/* Letter Testimonials */}
        <div className="space-y-8 max-w-4xl mx-auto">
          {letterTestimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-md hover:shadow-lg transition-shadow duration-300 overflow-hidden"
            >
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 p-6">
                {/* Left: Home Photo + Info */}
                <div className="flex flex-col items-center text-center">
                  <div className="w-full h-[200px] rounded-xl overflow-hidden mb-4">
                    <img
                      src={testimonial.homeImage}
                      alt={testimonial.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <h3 className="text-lg font-heading font-semibold text-[#2B6777] mb-1">
                    {testimonial.name}
                  </h3>
                  <p className="text-sm text-[#2B6777]/60 mb-2">{testimonial.location}</p>
                  <div className="flex items-center gap-1 px-3 py-1 bg-[#52AB98]/10 rounded-full">
                    <i className="ri-checkbox-circle-fill text-[#52AB98] text-sm"></i>
                    <span className="text-xs text-[#52AB98] font-medium whitespace-nowrap">Verified Homeowner</span>
                  </div>
                </div>

                {/* Right: Letter Content */}
                <div className="md:col-span-2 flex flex-col justify-center">
                  <div className="bg-[#F6D7DF]/10 rounded-xl p-6 border border-[#D98CA3]/10">
                    <div className="flex items-start mb-3">
                      <span className="text-4xl text-[#D98CA3] leading-none mr-2">"</span>
                      <p className="text-base text-[#2B6777] leading-relaxed pt-2">
                        {testimonial.letter}
                      </p>
                    </div>
                    <div className="flex justify-between items-center mt-4 pt-4 border-t border-[#2B6777]/10">
                      <p className="text-sm text-[#2B6777]/50">{testimonial.date}</p>
                      <div className="flex gap-1">
                        {[...Array(5)].map((_, i) => (
                          <i key={i} className="ri-star-fill text-[#52AB98] text-sm"></i>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Footer */}
        <div className="text-center mt-12">
          <p className="text-sm text-[#2B6777]/50 italic">
            We don't manufacture reviews. We earn them.
          </p>
        </div>
      </div>
    </section>
  );
}